import { jsx as _jsx } from "react/jsx-runtime";
import { Divider, makeStyles } from '@material-ui/core';
var useStyles = makeStyles(function (theme) { return ({
    divider: {
        backgroundColor: theme.palette.primary.light,
        height: '2px',
        width: '90%',
        marginBottom: theme.spacing(1)
        // borderRadius: '1px',
        // paddingLeft: '2px',
        // paddingRight:'2px'
    }
}); });
export var TextDecoration = function (_a) {
    var width = _a.width, _b = _a.fullWidth, fullWidth = _b === void 0 ? true : _b;
    var classes = useStyles();
    return (
    // <Flex marginX={1}>
    _jsx(Divider, { variant: fullWidth ? 'fullWidth' : 'middle', className: classes.divider, style: !!width ? { width: width } : undefined }, void 0)
    // </Flex>
    );
};
